import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  FormArray,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import {
  DialogService,
  DynamicDialogRef,
  DynamicDialogConfig,
  DynamicDialogModule,
} from 'primeng/dynamicdialog';
import { StepsModule } from 'primeng/steps'; // Import StepsModule
import { InputTextModule } from 'primeng/inputtext';
import { DatePicker } from 'primeng/datepicker';
import { Select } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag'; // Import TagModule
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription, forkJoin } from 'rxjs';
import {
  dateRangeValidator,
  formatDateToISO,
  formatPhoneNumber,
  idadeMinimaValidator,
} from '@validators/date-range.validator';
import { CalendarModule } from 'primeng/calendar';
import {
  CommunicationService,
  PaisService,
  ProvinciaService,
  MunicipioService,
  BolseiroService,
  EnumService,
} from '../../api/services';
import { AuthService } from '@core/service/auth.service';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { Utilizador } from '../../api/models/utilizador.model';
import { Bolseiro } from '../../api/models/bolseiro.model';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '@core/providers/http';
import { DropdownModule } from 'primeng/dropdown';
import { StepperModule } from 'primeng/stepper';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormGroup } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { FluidModule } from 'primeng/fluid';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { FileUpload } from 'primeng/fileupload';
import { BiService } from '@core/service/bi.service';

@Component({
  selector: 'app-cadastrar-bolseiros',
  imports: [
    ReactiveFormsModule,
    DialogModule,
    Select,
    InputTextModule,
    ButtonModule,
    StepperModule,
    StepsModule,
    DatePicker,
    CommonModule,
    FormsModule,
    BackButtonComponent,
    TableModule,
    DynamicDialogModule,
    CalendarModule,
    DropdownModule,
    InputMaskModule,
    TagModule, // Add TagModule to imports,
    RadioButtonModule,
    InputNumberModule,
    DatePickerModule,
    FluidModule,
    ConfirmDialogModule,
    ToastModule,
    FileUpload,
  ],
  providers: [
    DialogService,
    DynamicDialogRef,
    DynamicDialogConfig,
    MessageService,
    PaisService,
    ProvinciaService,
    MunicipioService,
    CommunicationService,
    BolseiroService,
    AuthService,
    ApiService,
    ConfirmationService,
    EnumService,
    BiService,
  ],
  templateUrl: './cadastrar-bolseiros.component.html',
  styleUrls: ['./cadastrar-bolseiros.component.scss'],
  standalone: true,
})
export class CadastrarBolseirosComponent implements OnInit, OnDestroy {
  dialogService = inject(DialogService);
  paisService = inject(PaisService);
  provinciaService = inject(ProvinciaService);
  municipioService = inject(MunicipioService);
  communicationService = inject(CommunicationService);
  bolseiroService = inject(BolseiroService);
  biService = inject(BiService);
  messageService = inject(MessageService);
  isLoading: boolean = false;
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  bolseiros: Bolseiro[] = [];
  utilizadores: Utilizador[] = [];
  private subscriptions = new Subscription();

  estadoCivilOptions: any[] = [];
  generoOptions: any[] = [];

  nivelAcademicoOptions: any[] = [];
  tipoBolsaOptions: any[] = [];
  tipoPedidoOptions: any[] = [];
  empresaGestoraOptions: any[] = [];
  rowIndex: number = 0;
  private authService = inject(AuthService);
  private enumService = inject(EnumService);
  private fb = inject(FormBuilder);
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  activeStep: number = 1;
  personalInfoForm: FormGroup = new FormGroup({});
  aidForm: FormGroup = new FormGroup({});
  institutionForm: FormGroup = new FormGroup({});
  instituicoes: FormArray = this.fb.array([]);
  bolseiroId: string | null = null;

  file: any;
  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL
  selectedFile: File | null = null;
  isInternalChange: boolean = false; // Flag to prevent infinite loop on valueChanges

  formKeys: string[] = [
    // 'id',
    // 'numeroBI',
    'nome',
    'dataEmissaoBI',
    'dataVencimentoBI',
    'dataNascimento',
    'estadoCivil',
    'genero',
    'nivelAcademicoID',
    'paisNascimento',
    'nomeMae',
    'nomePai',
    'idProvinciaResidencia',
    'idMunicipioResidencia',
    'idMunicipioNascimento',
    'contactoPrincipal',
    'enderecoResidencia',
    'endereco',
    'email',
    'contactoFamiliar',
    'contactoSecundario',
    // 'isActive',
    'Iban',
    'Banco',
    'NumeroConta',
    'Swift',
    // 'fotoBase64'
  ];
  constructor() {
    this.personalInfoForm = this.fb.group(
      {
        id: ['0'],
        numeroBI: ['', Validators.required],
        nome: [{ value: '', disabled: true }, Validators.required],
        dataEmissaoBI: [{ value: '', disabled: true }, Validators.required],
        dataVencimentoBI: [{ value: '' }, Validators.required],
        dataNascimento: [
          { value: '', disabled: true },
          [Validators.required, idadeMinimaValidator(15)],
        ],
        estadoCivil: ['', Validators.required],
        genero: [{ value: '', disabled: true }, Validators.required],
        nivelAcademicoID: ['1', Validators.required],
        // nacionalidadeID: ['', Validators.required],
        paisNascimento: ['', Validators.required],
        nomeMae: [{ value: '', disabled: true }, Validators.required],
        nomePai: [{ value: '', disabled: true }, Validators.required],
        idProvinciaResidencia: ['', Validators.required],
        idMunicipioResidencia: ['', Validators.required],
        idMunicipioNascimento: ['1'],
        contactoPrincipal: ['', Validators.required],
        enderecoResidencia: [
          { value: '', disabled: false },
          [Validators.required, Validators.minLength(5)],
        ],
        endereco: [{ value: '', disabled: false }],
        email: ['', [Validators.required, Validators.email]],
        contactoFamiliar: [''],
        contactoSecundario: [''],
        isActive: [true, Validators.required],
        Iban: [''],
        Banco: [''],
        NumeroConta: [''],
        Swift: [''],
        fotoBase64: [''],
      },
      {
        validators: dateRangeValidator(
          'dataEmissaoBI',
          'dataVencimentoBI',
          'dataEmissaVencimentoRange',
        ),
      },
    );

    this.personalInfoForm.controls['paisNascimento'].valueChanges.subscribe(
      (value) => {
        if (!value) return;
        this.onCountryChange(value);
      },
    );

    this.personalInfoForm.controls[
      'idProvinciaResidencia'
    ].valueChanges.subscribe((value) => {
      if (!value) return;
      this.onProvinceChange(value);
    });

    this.personalInfoForm.controls['numeroBI'].valueChanges.subscribe(
      (value) => {
        if (this.isInternalChange) return;

        this.formKeys.forEach((control) =>
          this.personalInfoForm.controls[control].setValue(null),
        );
      },
    );
  }

  resetFormExcept(exceptKey: string) {
    Object.keys(this.personalInfoForm.controls).forEach((key) => {
      if (key !== exceptKey) {
        this.personalInfoForm.controls[key].reset({
          value: this.personalInfoForm.controls[key].value ?? null,
          disabled: this.personalInfoForm.controls[key].disabled,
        });
      }
    });
  }

  getById(id?: any, array?: any) {
    return array.find((item: any) => item.id === id);
  }

  ngOnInit() {
    this.loadEnums();

    this.loadCountries();

    this.activatedRoute.queryParams.subscribe((params) => {
      this.bolseiroId = params['bolseiroId'];
      if (this.bolseiroId) {
        this.loadBolseiro(this.bolseiroId);
      }
    });
  }

  loadEnums() {
    forkJoin({
      tipoDocumento: this.enumService.getAllTipoDocumentoEnum(),
      tipoBolsa: this.enumService.getAllTipoBolsaEnum(),
      estadoCivil: this.enumService.getAllEstadoCivilEnum(),
      nivelAcademico: this.enumService.getAllNivelAcademicoEnum(),
      genero: this.enumService.getAllGeneroEnum(),
    }).subscribe((response) => {
      if (response.tipoBolsa?.data) {
        this.tipoBolsaOptions = Object.entries(response.tipoBolsa.data).map(
          ([key, value]) => ({
            id: Number(key),
            designacao: value,
          }),
        );
      }
      if (response.estadoCivil?.data) {
        this.estadoCivilOptions = Object.entries(response.estadoCivil.data).map(
          ([key, value]) => ({
            id: Number(key),
            designacao: value,
          }),
        );
      }
      if (response.nivelAcademico?.data) {
        this.nivelAcademicoOptions = Object.entries(
          response.nivelAcademico.data,
        ).map(([key, value]) => ({
          id: Number(key),
          designacao: value,
        }));
      }
      if (response.genero?.data) {
        this.generoOptions = Object.entries(response.genero.data).map(
          ([key, value]) => ({
            id: Number(key),
            designacao: value,
          }),
        );
      }
    });
  }

  loadBolseiro(bolseiroId: string) {
    this.isInternalChange = true; // Evitar loop infinito
    this.bolseiroId = bolseiroId;
    this.personalInfoForm.disable();
    [
      'dataEmissaoBI',
      'dataVencimentoBI',
      'enderecoResidencia',
      'contactoPrincipal',
      'estadoCivil',
      'paisNascimento',
      'idProvinciaResidencia',
      'email',
      'contactoFamiliar',
      'contactoSecundario',
      'nivelAcademicoID',
      'idMunicipioResidencia',
      'Banco',
      'Iban',
      'NumeroConta',
      'Swift',
    ].forEach((controlName) => {
      this.personalInfoForm.controls[controlName]?.enable();
    });
    this.bolseiroService.show(bolseiroId).subscribe({
      next: (response) => {
        if (response.retorno.codigo === 200) {
          this.isInternalChange = true;
          const bolseiro = response.data;
          this.personalInfoForm.patchValue({
            ...bolseiro,
            Banco: bolseiro.banco,
            Iban: bolseiro.iban,
            NumeroConta: bolseiro.numeroConta,
            Swift: bolseiro.swift,
            dataEmissaoBI: new Date(bolseiro.dataEmissaoBI),
            dataVencimentoBI: new Date(bolseiro.dataVencimentoBI),
            dataNascimento: new Date(bolseiro.dataNascimento),
            numeroBI: bolseiro.numeroBI,
            nivelAcademicoId: +bolseiro.nivelAcademicoId,
            enderecoResidencia: bolseiro.endereco,
            nivelAcademicoID: bolseiro.nivelAcademicoId,
            paisNascimento: bolseiro?.provinciaResidencia?.paisID,
            idProvinciaResidencia: bolseiro.provinciaResidenciaID,
            // idMunicipioResidencia: bolseiro.municipioResidenciaID,
            fotoBase64: bolseiro.fotoBase64,
          });

          this.loadMunicipalities(
            bolseiro.provinciaResidenciaID,
            bolseiro.municipioResidenciaID, // <-- passed in, set after list loads
          );
          // Se a Foto já estiver em base64, configura o preview
          this.bolseiroService
            .getBolseiroFotoById(bolseiro.id)
            .subscribe((response) => {
              if (!response) return;

              const file = new File([response], 'photo.jpg', {
                type: response.type,
              });
              this.selectedFile = file;

              const reader = new FileReader();
              reader.onload = () => {
                this.imagePreview = reader.result as string;
              };
              reader.readAsDataURL(file);

              this.personalInfoForm.patchValue({ Foto: file });
            });
        }
      },
      error: (err) => {
        console.error('Erro ao carregar bolseiro:', err);
      },
    });
  }

  onProvinceChange(value: any) {
    // Reset municipality when user manually changes province
    if (!this.isInternalChange) {
      this.personalInfoForm.patchValue({ idMunicipioResidencia: null });
    }
    this.loadMunicipalities(value); // no preSelectId = normal flow
  }

  onCountryChange(value: any) {
    console.log(value);
    this.loadProvinces(value);
  }

  resetProvinceAndMunicipality() {
    if (this.isInternalChange) return; // Evitar loop infinito
    this.isInternalChange = true;
    this.personalInfoForm.patchValue({
      idMunicipioResidencia: null,
      idProvinciaResidencia: null,
    });
  }

  resetMunicipality() {
    if (this.isInternalChange) return; // Evitar loop infinito
    this.isInternalChange = true;
    this.personalInfoForm.patchValue({
      idMunicipioResidencia: null,
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadCountries() {
    this.paisService.list().subscribe((countries) => {
      this.countries = countries;
    });
  }

  loadProvinces(country: string) {
    this.provinciaService.list(country).subscribe((provinces) => {
      this.provinces = provinces;
      this.municipalities = []; // Reset municipalities when country changes
    });
  }

  // Replace your existing loadMunicipalities method:
  loadMunicipalities(province: string, preSelectId?: any) {
    this.municipioService.list(province).subscribe((municipalities) => {
      this.municipalities = municipalities;

      // Patch the municipality AFTER the list is available
      if (preSelectId) {
        this.personalInfoForm.patchValue({
          idMunicipioResidencia: preSelectId,
        });
      }
    });
  }
  /**
  searchDocumentNumber() {
    this.authService
      .consultarBi(this.f.numeroBI.value)
      .subscribe((result) => {
        if (result.retorno.codigo == 200 && result.data) {
          this.personalInfoForm.patchValue({
            nome: `${result.data.nome} ${result.data.sobrenome}`,
            dataNascimento: new Date(result.data.dataNascimento) as any,
            estadoCivil: +result.data.estadoCivil as any,
            genero: +result.data.genero as any,
            nomeMae: `${result.data.nomeMae} ${result.data.sobrenomeMae}`,
            nomePai: `${result.data.nomePai} ${result.data.sobrenomePai}`,
            enderecoResidencia: result.data.morada,
            endereco: result.data.morada,
            contactoPrincipal: result.data.numeroContacto,
            dataEmissaoBI: new Date(result.data.dataEmissaoBi) as any,
            fotoBase64: result.data.fotoBase64,
          });
          this.personalInfoForm.controls['dataNascimento'].disable();

          const defaultCountry = this.countries.find(
            (country) => country.designacao === 'Angola'
          );

          if (defaultCountry) {
            this.personalInfoForm.patchValue({
              paisNascimento: defaultCountry.id,
            });
          }
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail:
              'Não foi possivel encontrar o cidadão com o número do BI fornecido.',
            life: 4000,
          });
        }
      });
  }
  */
  searchDocumentNumber() {
    const bi = (this.f.numeroBI?.value || '').trim();
    if (!bi) return;

    this.isLoading = true;

    this.biService.consultar(bi).subscribe({
      next: (result) => {
        this.isLoading = false;

        if (result?.retorno?.codigo === 200 && result?.data?.data) {
          const d = result.data.data;

          this.personalInfoForm.patchValue({
            nome: `${d.first_name ?? ''} ${d.last_name ?? ''}`.trim(),
            dataNascimento: d.birth_date ? new Date(d.birth_date) : null,
            genero: this.mapGeneroToEnumId(d.gender_name),
            estadoCivil: this.mapEstadoCivilToEnumId(d.marital_status_name),
            nomePai:
              `${d.father_first_name ?? ''} ${d.father_last_name ?? ''}`.trim(),
            nomeMae:
              `${d.mother_first_name ?? ''} ${d.mother_last_name ?? ''}`.trim(),
            enderecoResidencia: d.residence_address ?? null,
            endereco: d.residence_address ?? null,
            dataEmissaoBI: d.issue_date ? new Date(d.issue_date) : null,
            dataVencimentoBI: d.expiry_date ? new Date(d.expiry_date) : null,
          });

          ['dataEmissaoBI'].forEach((controlName) => {
            this.personalInfoForm.controls[controlName]?.enable();
          });
          // Mantém o comportamento atual: bloquear data de nascimento
          //this.personalInfoForm.controls['dataNascimento']?.disable();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail:
              'Não foi possível encontrar o cidadão com o número do BI fornecido.',
            life: 4000,
          });
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Erro ao consultar BI:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Falha ao consultar o BI. Tente novamente.',
          life: 4000,
        });
      },
    });
  }

  // Ajusta estes mapeamentos conforme os teus enums
  private mapGeneroToEnumId(g: string | null | undefined): number | null {
    if (!g) return null;
    const v = g.toUpperCase();
    if (v.includes('MASC')) return 1;
    if (v.includes('FEM')) return 2;
    return null;
  }

  private mapEstadoCivilToEnumId(e: string | null | undefined): number | null {
    if (!e) return null;
    const v = e.toUpperCase();
    if (v.includes('SOLTEIR')) return 1;
    if (v.includes('CASAD')) return 2;
    if (v.includes('DIVORCI')) return 3;
    if (v.includes('VIÚV') || v.includes('VIUV')) return 4;
    return null;
  }

  get f(): any {
    return {
      ...this.personalInfoForm.controls,
      ...this.aidForm.controls,
      ...this.institutionForm.controls,
    };
  }

  save() {
    if (this.personalInfoForm.valid) {
      if (this.isLoading) return;
      const formData = {
        ...this.personalInfoForm.getRawValue(),
      };
      if (this.bolseiroId) {
        this.updateBolseiro(this.bolseiroId, formData);
      } else {
        this.storeBolseiro(formData);
      }
    } else {
      this.personalInfoForm.markAllAsTouched();
      this.aidForm.markAllAsTouched();
      this.institutionForm.markAllAsTouched();

      this.messageService.add({
        severity: 'warn',
        summary: 'Campos obrigatórios não preenchidos',
        detail:
          'Por favor, preencha todos os campos obrigatórios corretamente antes de continuar.',
        life: 5000,
      });
    }
  }

  choose(event: any, callback: () => void) {
    callback();
  }

  onSelectedFiles(event: { currentFiles: any }) {
    this.file = event.currentFiles[0];

    //Adicionar validação de tamanho da imagem (ex: máx. 2MB)
    const maxSizeMB = 2;
    if (this.file.size > maxSizeMB * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Imagem muito grande',
        detail: `A imagem deve ter no máximo ${maxSizeMB}MB.`,
        life: 3000,
      });
      return;
    }

    const isImage = this.file.type.startsWith('image/');
    if (!isImage) {
      this.messageService.add({
        severity: 'error',
        summary: 'Formato inválido',
        detail: 'Apenas imagens são permitidas.',
        life: 3000,
      });
      return;
    }

    if (this.file) {
      this.selectedFile = this.file;
      this.personalInfoForm.patchValue({ fotoBase64: this.file });

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.file);
    }
    /*this.file = event.currentFiles[0];
    console.log(this.file);
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result; // Store Base64 URL
    };
    reader.readAsDataURL(this.file);*/
  }

  resetForm() {
    this.personalInfoForm.reset();
    this.router.navigate(['gestao-bolseiros/bolseiros/']);
  }

  private prepareFormData(data: any, includeFoto: boolean = true): FormData {
    const formValue = {
      id: data.id || '0',
      NumeroBI: data.numeroBI,
      Nome: data.nome,
      DataEmissaoBI: formatDateToISO(data.dataEmissaoBI),
      DataVencimentoBI: formatDateToISO(data.dataVencimentoBI),
      DataNascimento: formatDateToISO(data.dataNascimento),
      EstadoCivil: data.estadoCivil,
      Genero: data.genero,
      NivelAcademicoId: data.nivelAcademicoID,
      paisNascimento: data.paisNascimento,
      NomeMae: data.nomeMae,
      NomePai: data.nomePai,
      IdProvinciaResidencia: data.idProvinciaResidencia || 1,
      IdMunicipioResidencia: data.idMunicipioResidencia || 8,
      IdMunicipioNascimento: data.idMunicipioNascimento || 1,
      ContactoPrincipal: formatPhoneNumber(data.contactoPrincipal),
      EnderecoResidencia: data.enderecoResidencia,
      Endereco: data.endereco,
      Email: data.email,
      ContactoFamiliar: formatPhoneNumber(data.contactoFamiliar),
      ContactoSecundario: formatPhoneNumber(data.contactoSecundario),
      IsActive: data.isActive,
      Iban: data.Iban,
      Banco: data.Banco,
      NumeroConta: data.NumeroConta,
      Swift: data.Swift,
      Foto: data.fotoBase64,
    };

    const formData = new FormData();
    for (const key in formValue) {
      const typedKey = key as keyof typeof formValue;
      if (!formValue[typedKey]) continue;
      formData.append(key, String(formValue[typedKey]));
    }

    if (includeFoto && data.fotoBase64) {
      formData.append(
        'Foto',
        this.selectedFile as any,
        this.selectedFile?.name,
      );
    }

    return formData;
  }

  private handleResponse(
    response: any,
    successMessage: string,
    redirectPath: string,
    redirectId?: string,
  ): void {
    this.isLoading = false; // Parar carregamento
    if (response.retorno.codigo === 200) {
      this.messageService.add({
        severity: 'success',
        summary: 'Sucesso',
        detail: successMessage,
        life: 3000,
      });
      setTimeout(() => {
        this.router.navigate([redirectPath, redirectId || response.data.id]);
      }, 3000);
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: response.retorno.mensagem || 'Erro desconhecido.',
        life: 3000,
      });
    }
  }

  private handleError(error: any, errorMessage: string): void {
    console.error('Erro:', error);
    this.isLoading = false; // Parar carregamento
    this.messageService.add({
      severity: 'error',
      summary: 'Erro',
      detail: error.error?.retorno?.mensagem || errorMessage,
      life: 3000,
    });
  }

  storeBolseiro(data: any): void {
    this.isLoading = true; // Iniciar carregamento
    const formData = this.prepareFormData(data);

    this.bolseiroService.store(formData).subscribe({
      next: (response) =>
        this.handleResponse(
          response,
          'Estudante registado com sucesso!',
          'gestao-bolseiros/bolseiros/detalhe-bolseiro',
        ),
      error: (error) => this.handleError(error, 'Erro ao criar estudante.'),
    });
  }

  updateBolseiro(bolseiroId: string, data: any): void {
    this.isLoading = true; // Iniciar carregamento
    const formData = this.prepareFormData(data);

    this.bolseiroService.update(formData, bolseiroId).subscribe({
      next: (response) =>
        this.handleResponse(
          response,
          'Estudante actualizado com sucesso!',
          'gestao-bolseiros/bolseiros/detalhe-bolseiro',
          data.id || bolseiroId,
        ),
      error: (error) => this.handleError(error, 'Erro ao actualizar bolseiro.'),
    });
  }

  cancel() {
    this.ref.close(); // Fechar o diálogo sem salvar
  }

  getSeverity(status: string) {
    switch (status) {
      case 'Aprovado':
        return 'success';
      case 'em_curso':
        return 'info';
      case 'reprovado':
        return 'danger';
      case 'suspensa':
        return 'warn';
      case 'Pendente':
        return 'warn';
      default:
        return 'warn';
    }
  }

  getLabel(status: string) {
    switch (status) {
      case 'Aprovado':
        return 'Aprovado';
      case 'em_curso':
        return 'Em Curso';
      case 'reprovado':
        return 'Reprovado';
      case 'suspensa':
        return 'Suspensa';
      case 'Pendente':
        return 'Pendente';
      default:
        return 'Outro';
    }
  }
}
